import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesModule } from './pages/pages.module';
import { SearchModule } from './search/search.module';
import { GlobalState } from './state';
import { ApiModule } from './api/api.module';
import { AuthModule } from './auth/auth.module';
import { ChatModule } from './chat/chat.module';
import "@angular/compiler";
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { definePreset } from '@primeng/themes';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "@ngxs/storage-plugin";
import * as i3 from "./shared/shared.module";
const MyPreset = definePreset(environment.theme, {
    //Your customizations, see the     
    options: {
        cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
        }
    },
    semantic: {
        primary: {
            50: `{${environment.primary}.500}`,
            100: `{${environment.primary}.100}`,
            200: `{${environment.primary}.200}`,
            300: `{${environment.primary}.300}`,
            400: `{${environment.primary}.400}`,
            500: `{${environment.primary}.500}`,
            600: `{${environment.primary}.600}`,
            700: `{${environment.primary}.700}`,
            800: `{${environment.primary}.800}`,
            900: `{${environment.primary}.900}`,
            950: `{${environment.primary}.950}`
        },
        secondary: {
            50: `{${environment.secondary}.50}`,
            100: `{${environment.secondary}.100}`,
            200: `{${environment.secondary}.200}`,
            300: `{${environment.secondary}.300}`,
            400: `{${environment.secondary}.400}`,
            500: `{${environment.secondary}.500}`,
            600: `{${environment.secondary}.600}`,
            700: `{${environment.secondary}.700}`,
            800: `{${environment.secondary}.800}`,
            900: `{${environment.secondary}.900}`,
            950: `{${environment.secondary}.950}`
        },
        tertiary: {
            50: `{${environment.tertiary}.50}`,
            100: '{lime.100}',
            200: `{${environment.tertiary}.200}`,
            300: `{${environment.tertiary}.300}`,
            400: `{${environment.tertiary}.400}`,
            500: `{${environment.tertiary}.500}`,
            600: `{${environment.tertiary}.600}`,
            700: `{${environment.tertiary}.700}`,
            800: `{${environment.tertiary}.800}`,
            900: `{${environment.tertiary}.900}`,
            950: `{${environment.tertiary}.950}`
        },
    },
});
export class AppModule {
    static ɵfac = function AppModule_Factory(t) { return new (t || AppModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [AppComponent] });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            provideAnimationsAsync(),
            providePrimeNG({
                theme: {
                    preset: MyPreset,
                    options: {
                        darkModeSelector: '.my-app-dark',
                        cssLayer: {
                            name: 'primeng',
                            order: 'theme, base, primeng'
                        }
                    }
                },
            }),
        ], imports: [NgxsModule.forRoot([GlobalState], { developmentMode: !environment.production }),
            AuthModule,
            ApiModule,
            PagesModule,
            BrowserModule,
            BrowserAnimationsModule,
            AppRoutingModule,
            NgxsStoragePluginModule.forRoot({
                keys: '*',
            }),
            SearchModule,
            SharedModule.forRoot(),
            ChatModule] });
}
